export function getBackendErrorMessage(error, fallback) {
  const safeFallback = typeof fallback === 'string' && fallback.trim() ? fallback.trim() : 'Ocurrió un error';

  try {
    const data = error?.response?.data;
    const status = error?.response?.status;

    const backendMsg =
      (typeof data?.error === 'string' && data.error.trim()) ||
      (typeof data?.message === 'string' && data.message.trim()) ||
      (typeof data?.msg === 'string' && data.msg.trim());

    if (backendMsg) {
      if (typeof status === 'number') {
        return `${backendMsg} (HTTP ${status})`;
      }
      return backendMsg;
    }

    if (typeof error?.message === 'string' && error.message.trim()) {
      return error.message;
    }

    return safeFallback;
  } catch {
    return safeFallback;
  }
}
